import type { SceneNode } from "@/document/model/nodes";
import type { VectorNetwork } from "@/document/model/vectorNetwork";
import type { Point } from "@/document/operations/pathGeometry";
import { VECTOR_CURVE_TOLERANCE } from "@/document/operations/curveKernels";

export interface CachedPathMesh {
  key: string;
  contours: Point[][];
  fillContours?: Point[][];
  vertices: Float32Array;
  fillVertices?: Float32Array;
  fillVertexChunks?: Float32Array[];
  fillGroups?: FillContourGroup[];
  strokeVerticesByWidth: Map<string, Float32Array>;
}

export interface FillContourGroup {
  contours: Point[][];
  edgeRefs: Array<Array<{ edgeId: string; forward: boolean }>>;
  edgeIds: string[];
  vertices: Float32Array;
}

export const pathMeshCache = new WeakMap<SceneNode, CachedPathMesh>();

export const networkMeshCache = new WeakMap<VectorNetwork, CachedPathMesh & { closed: boolean }>();

/** Internal TS stroke-kernel chunk cache (stays number[] — packed by tsPackedBackend). */
export const strokeTriangleChunkCacheByKey = new Map<string, number[]>();

export const fillTriangleChunkCacheByKey = new Map<string, Float32Array>();

export const unchangedFillChunkCacheByKey = new Map<string, Float32Array>();

/** Cap for stroke/fill chunk Maps. GeometryPool has its own LRU (4096). */
export const maxGeometryCacheEntries = 4096;

export const maxStrokeChunkCacheEntries = 4000;

export const maxFillChunkCacheEntries = 4000;

export const maxUnchangedFillChunkCacheEntries = 1000;

export const fillChunkGroupThreshold = 16;

export const vectorCurveTolerance = VECTOR_CURVE_TOLERANCE;

export const strokeTriangleChunkPointSize = 192;
